export default {
  spritzConfigs: {
    proxy: {
      name: 'CoreProxy',
      group: 'LINKUSD',
    },
    syntheticToken: {
      name: 'SyntheticToken',
      group: 'LINKUSD',
    },
    collateralAsset: {
      name: 'CollateralToken',
      group: 'LINKUSD',
    },
    oracle: {
      name: 'Oracle',
      group: 'LINKUSD',
    },
    state: {
      name: 'SpritzState',
      group: 'LINKUSD',
    },
  },
  rewardPools: [],
  volatileCollaterals: ['LINK'],
  curvePool: {
    minimalPoolPartPercentage: '40',
    poolRegistryAddress: '0x0959158b6040D32d04c301A72CBFD6b39E21c9AE',
    poolAddress: '0x3252eFd4EA2d6c78091a1f43982ee2C3659cC3D1',
    depositZap: '0xA79828DF1850E8a3A3064576f380D90aECDD3359',
  },
}
